<footer *ngIf="isLoggedIn === true && isLoginPage === false" class="bg-white footer-bar">
	<div style="float: right; padding-right: 20px; line-height: 26px">v.{{ version }}</div>
	<div style="min-height: 1px" class="bg-light"></div>
	<div class="container-fluid text-dark">
		<div class="d-flex">
			<div class="me-4">&copy;{{ currentYear }} JobSight</div>
			<div *ngIf="isDebug" class="bg-danger text-white px-5">DEV SERVER</div>
			<div *ngIf="isStaging" class="bg-danger text-white px-5">STAGING SERVER</div>
			<div *ngIf="isLearningPaths" class="bg-danger text-white px-5">LEARNING PATHS SERVER</div>
			<div *ngIf="isRC" class="bg-danger text-white px-5">RELEASE CANDIDATE SERVER</div>
			<div *ngIf="isHotfix" class="bg-danger text-white px-5">HOTFIX SERVER</div>
		</div>
	</div>
</footer>
